<template lang="pug">
v-list-item-group
  v-skeleton-loader.my-4(
    v-for="(el, i) in listLength",
    :key="i",
    type="list-item-avatar",
    loading
  )
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "AttachmentListItemSkeleton",
  props: {
    listLength: { type: Number, required: true },
  },
})
</script>
